export const transition = 'transition duration-100 ease-in';
